import { VisitMedicalServiceTableBean } from '../medicalServices/medicalServices.types';

export const practitionerPriceDifferentFromServicePrice = (
   medicalServices: VisitMedicalServiceTableBean[]
): boolean => {
   return medicalServices.some(({ price, medicalService }) => price !== medicalService.priceListPrice);
};
